import { faStar as faStarRegular } from '@fortawesome/pro-regular-svg-icons';
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, UnstyledButton } from '@mantine/core';

const HEADQUARTER_STAR_ACTIVE_COLOR = '#C7AE85';

type StarActionPropsType = {
  isActive: boolean;
  tooltipActive: string;
  tooltipInactive: string;
  onClick: () => void;
};

export const StarAction: React.FC<StarActionPropsType> = ({
  isActive,
  tooltipActive,
  tooltipInactive,
  onClick,
}) => {
  const tooltipLabel = isActive ? tooltipActive : tooltipInactive;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <Tooltip label={tooltipLabel}>
      <UnstyledButton onClick={handleClick} aria-label={tooltipLabel}>
        <FontAwesomeIcon
          icon={isActive ? faStarSolid : faStarRegular}
          style={
            isActive ? { color: HEADQUARTER_STAR_ACTIVE_COLOR } : undefined
          }
        />
      </UnstyledButton>
    </Tooltip>
  );
};
